import { render, staticRenderFns } from "./bottomContNew.vue?vue&type=template&id=0435a375&scoped=true"
import script from "./bottomContNew.vue?vue&type=script&lang=js"
export * from "./bottomContNew.vue?vue&type=script&lang=js"
import style0 from "./bottomContNew.vue?vue&type=style&index=0&id=0435a375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435a375",
  null
  
)

export default component.exports